const groupCls = "_275gwnhzes";
const limitedMessage = "_275l1jnyblp";

export { groupCls, limitedMessage };
import "./root.style.linaria.module.css";
//# sourceMappingURL=root.style.js.map
